export const LIBERTY_PUBLIC_LOGO_URL = "https://img1.wsimg.com/isteam/ip/32d79ff3-b0eb-469d-845d-a3dabd912352/Front%20LLR%20logo.jpg/:/rs=w:500,h:400,cg:true,m/cr=w:500,h:400/qt=q:95";

export const LIBERTY_PUBLIC_HERO_URL = "https://img1.wsimg.com/isteam/stock/17007/:/fx-gs/rs=w:1438,h:959";

export function libertyFacilityLine() {
  return "1,000 yard range, 600 yard range, 100 yard ranges, 180\u00b0 range, 50 yard private mixed use ranges and a pistol range.";
}

export function libertyOpeningPhaseItems(resources = []) {
  const labels = new Set(resources.map((resource) => `${resource?.name || ""} ${resource?.type || ""}`.toLowerCase()));
  const has = (pattern) => Array.from(labels).some((label) => label.includes(pattern));

  return [
    {
      title: "Flat Range",
      status: has("flat") ? "Open" : "Opening phase",
      detail: "Primary zeroing, qualification, and controlled training blocks.",
    },
    {
      title: "600 yd Known Distance",
      status: has("600") ? "Open" : "Opening phase",
      detail: "Structured long-range progression and match preparation.",
    },
    {
      title: "2000 yd Known Distance",
      status: has("2000") ? "Scheduled access" : "Opening phase",
      detail: "Extended-distance training windows for qualified shooters.",
    },
    {
      title: "MOUT Town",
      status: has("mout") ? "Training blocks" : "Opening phase",
      detail: "Scenario-based facility access through organized programs.",
    },
  ];
}

export function libertyRangeFacts(range = {}) {
  return [
    { label: "Access model", value: "Members only" },
    { label: "Long-range capability", value: "1,000 yards planned" },
    { label: "Range mix", value: "Pistol, rifle, private bays" },
    { label: "Safety gate", value: "Orientation + qualification" }
  ];
}

export function libertyRangeStory() {
  return [
    {
      title: "Limited membership launch",
      body: "Liberty Long Range is preparing a members-only outdoor range with limited capacity so the property stays useful, private, and safe."
    },
    {
      title: "Phased opening",
      body: "Shorter ranges are planned first, then the 1,000 yard range opens in a controlled schedule while expansion work continues."
    },
    {
      title: "Safety-first access",
      body: "Members should expect a release form, background check, orientation, and a separate qualification path for the gated 1,000 yard area."
    }
  ];
}
